import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=995f1848&scoped=true"
import script from "./Zone.vue?vue&type=script&lang=js"
export * from "./Zone.vue?vue&type=script&lang=js"
import style0 from "./Zone.vue?vue&type=style&index=0&id=995f1848&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995f1848",
  null
  
)

export default component.exports